import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {TypeBagsWeight, StatusBag} from "@app/enums";
import { BagAncillarieInt, BagPassangerInt } from '@app/interfaces';
import { Passenger, Reservation } from '@app/models';
import { BagsService } from '@app/services/bags.service';
import { Bags20kgOnlyWebAppModalComponent } from '@app/shared/modals/bags-20kg-only-web-app-modal/bags-20kg-only-web-app-modal.component';
import { unsubscribe } from '@app/utils';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Subscription } from 'rxjs';

/**
 * Componente para gestionar y visualizar la tabla de selección de equipaje.
 */
@Component({
    selector: 'am-bags-table',
    templateUrl: './am-bags-table.component.html',
    styleUrls: ['./am-bags-table.component.scss'],
    standalone: false
})
export class AmBagsTableComponent implements OnInit, OnDestroy {

   // #region Vars input
  /**
   * Lista de maletas adicionales disponibles para los pasajeros.
   * 
   * @type {BagAncillarieInt[]}
   */
  @Input() extraBags: BagAncillarieInt[]; 

  /**
   * Tipo de tarifa del pasajero.
   * 
   * @type {string}
   */
  @Input() fareFamily: string;

  /**
   * Información de la reserva actual.
   * 
   * @type {Reservation}
   */
  @Input() reservation: Reservation; 

  /**
   * Indica si el pago por maleta está habilitado.
   * 
   * @type {boolean}
   * @default true
   */
  @Input() hasBagPayment: boolean = true;

  /**
   * Indica si hay maletas de 20kg disponibles.
   * 
   * @type {boolean}
   * @default false
   */
  @Input() hasBags20Kg: boolean = false;

  /**
   * Indica si hay maletas de 25kg disponibles.
   * 
   * @type {boolean}
   * @default false
   */
  @Input() hasBags25Kg: boolean = false;

  /**
   * Indica si hay maletas de 32kg disponibles.
   * 
   * @type {boolean}
   * @default false
   */
  @Input() hasBags32Kg: boolean = false;

  /**
   * Indica si se puede canjear equipaje.
   * 
   * @type {boolean}
   * @default false
   */
  @Input() hasRedeeme: boolean = false;

  /**
   * Lista de pasajeros en la reserva.
   * 
   * @type {Passenger[]}
   */
  @Input() passengers: Passenger[];

  /**
   * Indica si el pasajero tiene tarifa Premier.
   * 
   * @type {boolean}
   * @default false
   */
  @Input() isPremier: boolean = false;

    /**
   * Controla la vista del modo Premier.
   * Al cambiar su valor, se actualiza el estado global del equipaje.
   * 
   * @param value Indica si la vista Premier está activa.
   */

   @Input() set setViewPremier(value: boolean) {
    this.isViewPremier = value;
    if (this.isViewPremier && this.passengers) {
      this.getStatusGlobalBags();
    }
   }

   /**
   * Evento emitido cuando se actualiza el estado del equipaje.
   */
   @Output() updateBags: EventEmitter<any> = new EventEmitter();

   /**
    * Evento emitido cuando se canjea un equipaje.
    */
   @Output() redeem: EventEmitter<any> = new EventEmitter();
  // #endregion Vars input

  bags20KGPaid:BagPassangerInt[];
  bags25KGPaid:BagPassangerInt[];
  bags32KGPaid:BagPassangerInt[];
  BagsWeight = TypeBagsWeight; 
  currencyCodeBags: string;
  isViewPremier: boolean = false;
  StatusBag = StatusBag;
  statusGlobalBags: StatusBag;
  totalAmountBags: number = 0;
  subs: Array<Subscription> = [];
  isDomestic:boolean;

  constructor(
    private modalService: NgbModal,
    private _bagsServide: BagsService
  ) {}


  ngOnInit(): void {
    this.initPage();
  }

  ngOnDestroy(): void {
    unsubscribe(this.subs)
  }

  // #region Functions internals
  initPage(){
    if(this.passengers){
      this.isDomestic = this.reservation?.flightSummary?.isDomestic
      this.getStatusGlobalBags();
      this.getBagsPrePaid();
      this.initSubscribe();
    }
  }

  initSubscribe(){
    const subsUpdateGlobal = this._bagsServide.getUpdateTableGlobalStatusBags().subscribe(update=>{
      if(update){
        this.getStatusGlobalBags();
      }
    })
    this.subs.push(subsUpdateGlobal)
  }
 /**
   * Calcula el estado global del equipaje basado en los pasajeros.
   */
  getStatusGlobalBags(){
    const statusPassangers = this.passengers.map(x => { return this.getStatusBagColumnPassenger(x)});
    const bagsReeemedAplied = statusPassangers.find(x => x == StatusBag.REDEEMED_APPLIED);
    const bagsInclude = statusPassangers.find(x => x == StatusBag.INCLUDE);
    const bagsPaid = statusPassangers.find(x => x == StatusBag.PAID);
    const bagsToPay = statusPassangers.find(x => x == StatusBag.TO_PAY);

    if(bagsToPay) {
      if(!this.isPremier || (this.isPremier && this.isViewPremier )){
        this.statusGlobalBags = StatusBag.TO_PAY;
      }
    }else if (bagsPaid) { 
      this.statusGlobalBags = StatusBag.PAID;
    }else if (bagsReeemedAplied) {
      if(!this.isPremier || (this.isPremier && this.isViewPremier )){
        this.statusGlobalBags = StatusBag.REDEEMED_APPLIED;
      }
    }else if(bagsInclude)
      this.statusGlobalBags = StatusBag.INCLUDE;
    else
      this.statusGlobalBags = StatusBag.NONE
    this.totalAmountBags = 0;
    if(this.statusGlobalBags == StatusBag.TO_PAY) {
      this.passengers.map(x=> {
        const bags = x.bagStack.filter(bag=> bag.statusBag == StatusBag.TO_PAY);
        bags?.map(x=> {
          this.totalAmountBags += x.currency?.total || 0;
          this.currencyCodeBags = x.currency?.currencyCode || ''
        })
      });
    }

    this.updateBags.emit({
      totalAmountBags : this.totalAmountBags,
      currencyCodeBags: this.currencyCodeBags
    });
  }

   /**
   * Obtiene la cantidad total de maletas seleccionadas por tipo de peso.
   * 
   * @param bagWeight Peso del equipaje.
   * @returns Número total de maletas seleccionadas.
   */

  totalBagsForWeight(bagWeight: TypeBagsWeight){
    let total = 0;

    this.passengers.map(passenger => {
      total += passenger.bagStack.filter(bag=> bag.typeBagWeight == bagWeight && bag.selected)?.length || 0
    });

    return total;
  }

  getBagsPrePaid() {
    this.bags20KGPaid = [];
    this.bags25KGPaid = [];
    this.bags32KGPaid = [];

    for(const passenger of  this.passengers){
      this.bags20KGPaid.push(...passenger.bagsPrePaid(TypeBagsWeight._20KG));
      this.bags25KGPaid.push(...passenger.bagsPrePaid(TypeBagsWeight._25KG));
      this.bags32KGPaid.push(...passenger.bagsNotUsed(TypeBagsWeight._32KG));
    };
    
    this.bags20KGPaid.map(bag => bag.selected = true);
    this.bags25KGPaid.map((bag) => bag.selected = true);
    this.bags32KGPaid.map((bag) => bag.selected = true);
  }

  getStatusBagColumnPassenger(passenger:Passenger){
    if(this.isPremier){
      return passenger.getStatusBagColumnPremier(this.isViewPremier);
    }else{
      return passenger.getStatusBagColumn();
    }
  }

  get isReviewBags(){
    return !this.isViewPremier && (this.bags20KGPaid?.length > 0 || this.bags25KGPaid?.length > 0) && this.isPremier;
  }

  // #endregion Functions internals

  // #region Events
  onRedeemed(event, passenger){
    this.redeem.emit({event, passenger})
  }
  handleCountBags($event){
    this.getStatusGlobalBags();
  }

  handleOpenModal20kg() {
    this.modalService.open(Bags20kgOnlyWebAppModalComponent,
      {
        centered: true,
        size: 'lg',
        backdrop : 'static',
        keyboard : false,
        windowClass: 'Bags20kgOnlyWebAppModal-content'
      }
    );
  }
  // #endregion Events

}
